import { atom } from 'jotai'
import { allDaysInTimelineAtom, timelineMinimumsAtom } from './timeline.atom'
import { DAY_RESOLUTION_PX } from '../timeline.constants'

export const expandedAtom = atom(false)

export const timelineLeftScrollPositionAtom = atom(0)

export const timelineContainerRefAtom = atom(null as HTMLDivElement | null)

export const timelineWidthAtom = atom<number>(get => {
  const allDaysInTimeline = get(allDaysInTimelineAtom)

  return allDaysInTimeline.length * DAY_RESOLUTION_PX
})

export const hoverPositionAtom = atom<number | null>(null)

export const hoveredMinimumAtom = atom<string | null>(null)

export const productsToHighlightAtom = atom<string[] | null>(get => {
  const hoveredMinimum = get(hoveredMinimumAtom)
  const timelineMinimums = get(timelineMinimumsAtom)

  if (!hoveredMinimum) {
    return null
  }

  const minimum = timelineMinimums.find(m => m.id === hoveredMinimum)

  return minimum?.productIds ?? null
})
